import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { CourseItem, Course } from '../models';

export class CourseApi extends ApiModule {
  protected endpoint = '/course';

  public async pageCourses(params: any) {
    return this.api.post<PaginatedResponseData<CourseItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadCourseDetails(id: number) {
    return this.api.get<Course>(`${this.endpoint}?id=${id}`);
  }

  public saveCourse(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteCourse(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
